import { Navigate } from 'react-router-dom';

import { LoadingLogo } from '@/components/shared/LoadingLogo';
import { useTenantSwitcher } from '@/contexts/TenantSwitcherContext';
import { useAuth } from '@/hooks/useAuth';

export function RootRedirect(): JSX.Element {
  const { user, isLoading } = useAuth();
  const { activeTenant, loadingTenant } = useTenantSwitcher();

  if (isLoading || loadingTenant) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <LoadingLogo size="lg" />
      </div>
    );
  }

  // Root users without active tenant should go to tenants page
  // (only redirect if we're sure there's no tenant after loading completes)
  if (user?.role === 'root' && !activeTenant && !loadingTenant) {
    return <Navigate to="/tenants" replace />;
  }

  // User role cannot see dashboard; send to items
  if (user?.role === 'user') {
    return <Navigate to="/items" replace />;
  }

  // Otherwise, go to dashboard
  return <Navigate to="/dashboard" replace />;
}
